import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function LegalPage({ doc, testId, desc }) {
  return (
    <main className="pt-32 pb-24 lg:pb-32" data-testid={testId}>
      <Seo
        title={`${doc.title} — MyFXPocket`}
        description={desc}
        path={`/${testId.replace("-page", "")}`}
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex items-center gap-4 mb-6">
            <span className="eyebrow">Legal</span>
            <span className="h-px w-10 bg-gradient-to-r from-[#FFD700] to-transparent" />
            <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#999999]">{doc.updated}</span>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-[-0.05em] text-white leading-[1.1]">
            {doc.title}
          </h1>
          {doc.intro && (
            <p className="mt-5 text-base text-[#999999] leading-relaxed">{doc.intro}</p>
          )}
        </Reveal>

        <div className="mt-12 space-y-10">
          {doc.sections.map((s, i) => (
            <Reveal key={i} delay={Math.min(i * 0.03, 0.2)}>
              <section data-testid={`${testId}-section-${i}`}>
                <h2 className="text-lg sm:text-xl font-semibold tracking-[-0.02em] text-white mb-3 flex items-baseline gap-3">
                  <span className="text-xs font-bold text-[#FFD700] shrink-0">{String(i + 1).padStart(2, "0")}</span>
                  {s.heading}
                </h2>
                <div className="space-y-3 pl-8">
                  {(s.paras || []).map((p, j) => (
                    <p key={j} className="text-sm text-[#999999] leading-relaxed">{p}</p>
                  ))}
                  {(s.clauses || []).map((c, j) => (
                    <div key={`c${j}`}>
                      <p className="text-sm text-[#999999] leading-relaxed">
                        <span className="text-[#FFD700]/80 font-semibold mr-2 tabular-nums">{c.n}</span>
                        {c.t}
                      </p>
                      {c.items && (
                        <ul className="list-disc list-outside pl-8 mt-2 space-y-1.5">
                          {c.items.map((li, k) => (
                            <li key={k} className="text-sm text-[#999999] leading-relaxed">{li}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                  {s.list && (
                    <ul className="list-disc list-outside pl-5 space-y-2">
                      {s.list.map((li, j) => (
                        <li key={j} className="text-sm text-[#999999] leading-relaxed">{li}</li>
                      ))}
                    </ul>
                  )}
                  {(s.extra || []).map((p, j) => (
                    <p key={`x${j}`} className="text-sm text-[#999999] leading-relaxed">{p}</p>
                  ))}
                </div>
              </section>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}
